  <!--
   功能名称:千里眼平台(技师)-会员管理(生日祝福)
   开发人:梁高权
   创建时间:2021/03/15
   最后修改时间:2021/03/15
   -->
<template>
<div class="memberBlessing-wrap">
  <NavBar/>
  <van-form @submit="onSubmit">
    <div class="form">
      <div class="head">
        <span>手机号码</span>
        <i>{{phone}}</i>
      </div>
      <div class="form-item">
        <div style="width: 300px;">呢称</div>
        <van-field v-model="member_nick" input-align="right" name="member_nick"/>
      </div>
      <div class="form-item" style="border: none;">
        <div>祝福内容</div>
        <div class="right" style="color: #4E57FB;" @click="$router.push('blessingTemplate')">更换模板<van-icon style="position: relative;top:3px" color="#4E57FB" name="arrow" size="15" /></div>
      </div>
      <van-field v-model="text" type="textarea" autosize/>
    </div>
    <div style="margin: 16px;">
      <van-button style="border-radius: 8px;" color="#4E57FB" block type="info" native-type="button" v-clipboard:copy="text" v-clipboard:success="onCopy" v-clipboard:error="onError">保存到剪贴板</van-button>
    </div>
  </van-form>
</div>
</template>

<script>
import { Toast } from 'vant';
import { mapState} from 'vuex'
export default{
  name:'memberBlessing',
  components: {'NavBar':() => import('@/components/NavBar')},
  data() {
    return {
      phone:'',
      member_nick: '',
      text:''
    };
  },
  computed: {...mapState(['technician'])},
  mounted() {
    let {phone, member_nick}=this.technician.radioMember;
    this.phone=phone;
    this.member_nick=member_nick;
    this.text=this.technician.blessing
  },
  methods:{
    // 复制成功时的回调函数
    onCopy(e) {
      Toast.success('复制成功');
    },
    // 复制失败时的回调函数
    onError(e) {
      Toast.fail('复制失败')
    },
    onSubmit(values) {
      console.log('submit', values);

    }
  }
}
</script>

<style lang="scss" scoped>
.memberBlessing-wrap{
.form{
  margin: 30px;
  padding: 30px 30px 45px;
  border-radius: 16px;
  background: #fff;
  .head{
    display: flex;
    flex-direction: column;
    span{
      font-size: 22px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #999999;
      line-height: 67px;
    }
    i{
      font-size: 36px;
      font-family: PingFang SC;
      font-weight: bold;
      color: #333333;
      line-height: 67px;
    }
  }
  .form-item{
    display: flex;
    padding: 25px 0;
    border-bottom: 2px solid #F5F5F5;
    >div:nth-child(1){
      font-size: 28px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #999999;
    }
    .right{
      flex: 1;
      text-align: right;
      font-size: 28px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #333333;
    }
  }
}
}
</style>
